module.exports = __webpack_public_path__ + "img/Plan-de-travail 40@2x-100.daf3e86f.jpg";